type CompanySummary = {
    id: string;
    name: string;
    numberOfUsers: number;
    numberOfPermits: number;
    numberOfCompanyDepartments: number;
    createdAt: Date;
    canUpdate: boolean;
    canDelete: boolean;
};

export default CompanySummary;

export function CompanySummary_empty(): CompanySummary {
    return {
        createdAt: new Date(),
        name: "",
        numberOfPermits: 0,
        numberOfUsers: 0,
        numberOfCompanyDepartments: 0,
        id: "",
        canDelete: false,
        canUpdate: false
    };
}

export function CompanySummary_normalize(company: CompanySummary): CompanySummary {
    return {
        canDelete: company.canDelete ?? false,
        canUpdate: company.canUpdate ?? false,
        createdAt : company.createdAt ? new Date(company.createdAt) : new Date(),
        id: company.id ?? "",
        name: company.name ?? "",
        numberOfPermits: company.numberOfPermits ?? 0,
        numberOfUsers: company.numberOfUsers ?? 0,
        numberOfCompanyDepartments: company.numberOfCompanyDepartments ?? 0
    }
}
